module.exports = __webpack_public_path__ + "static/img/结束.b3b838c8.svg";